var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthMsisdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 56,
    viewBox: "0 0 38 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11711_90)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11711_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 0H0V56H37.3333V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11711_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3521 10.8502C21.3521 14.2248 18.6026 17.0013 15.1657 17.0013C11.7717 17.0013 8.97925 14.2675 8.97925 10.8502C8.97925 7.47572 11.7288 4.69922 15.1657 4.69922C18.5596 4.69922 21.3521 7.47572 21.3521 10.8502Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 46.217H12.3731C11.8146 46.217 11.385 45.7898 11.385 45.2345C11.385 41.0911 7.99104 37.7166 3.8238 37.7166C1.7187 37.7166 0.0432129 36.008 0.0432129 33.9149C0.0432129 31.8219 1.76166 30.1132 3.8238 30.1132C6.53036 30.1132 9.10804 30.7967 11.385 32.1209V10.8486C11.385 9.82338 11.7716 8.88364 12.502 8.15748C13.2323 7.43131 14.1775 7.04688 15.2085 7.04688C16.2396 7.04688 17.1848 7.43131 17.9151 8.15748C18.6454 8.88364 19.0321 9.82338 19.0321 10.8486V20.6304C19.5906 20.3314 20.192 20.1605 20.8794 20.1605C21.9105 20.1605 22.8556 20.545 23.586 21.2711C23.6289 21.3138 23.6719 21.3566 23.7149 21.3993C23.7578 21.3566 23.8008 21.3138 23.8437 21.2711C24.5741 20.545 25.5192 20.1605 26.5073 20.1605C27.5384 20.1605 28.4836 20.545 29.2139 21.2711C29.2569 21.3138 29.2998 21.3566 29.3428 21.3993C29.3858 21.3566 29.4287 21.3138 29.4717 21.2711C30.202 20.545 31.1472 20.1605 32.1782 20.1605C33.2093 20.1605 34.1544 20.545 34.8418 21.2711C35.5722 21.9973 35.9588 22.937 35.9588 23.9622V45.2772C35.8729 45.7898 35.4003 46.217 34.8848 46.217ZM13.2753 44.2521H33.8537V23.9622C33.8537 23.4923 33.6819 23.0225 33.2952 22.6807C32.9515 22.339 32.479 22.1682 32.0064 22.1682C31.5338 22.1682 31.0612 22.339 30.7176 22.6807C30.3739 23.0225 30.1591 23.4923 30.1591 23.9622C30.1591 24.5175 29.7294 24.9447 29.1709 24.9447C28.6124 24.9447 28.1828 24.5175 28.1828 23.9622C28.1828 23.4923 28.011 23.0225 27.6673 22.6807C27.3236 22.339 26.851 22.1682 26.3785 22.1682C25.9059 22.1682 25.4333 22.339 25.0896 22.6807C24.7459 23.0225 24.5311 23.4923 24.5311 23.9622C24.5311 24.5175 24.1015 24.9447 23.543 24.9447C22.9845 24.9447 22.5549 24.5175 22.5549 23.9622C22.5549 23.4923 22.3831 23.0225 22.0394 22.6807C21.6957 22.339 21.2231 22.1682 20.7505 22.1682C20.278 22.1682 19.8054 22.339 19.4617 22.7235C19.118 23.0652 18.9462 23.5351 18.9462 24.0049C18.9462 24.5602 18.5166 24.9874 17.9581 24.9874C17.3996 24.9874 16.9699 24.5602 16.9699 24.0049V10.8486C16.9699 10.3787 16.7981 9.90881 16.4544 9.56709C16.1107 9.22536 15.6381 9.0545 15.1656 9.0545C14.693 9.0545 14.2204 9.22536 13.8767 9.56709C13.533 9.90881 13.3612 10.3787 13.3612 10.8486V34.0004C13.3612 34.3848 13.1464 34.7265 12.8027 34.8974C12.459 35.0682 12.0724 35.0255 11.7716 34.8119C9.45173 33.0606 6.70221 32.1636 3.8238 32.1636C2.83569 32.1636 2.01943 32.9752 2.01943 34.0004C2.01943 34.9828 2.83569 35.8371 3.8238 35.8371C8.72139 35.7517 12.8027 39.5107 13.2753 44.2521Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4048 48.5664C32.264 48.5664 32.9514 49.2499 32.9514 50.1042C32.9514 50.9585 32.264 51.6419 31.4048 51.6419C30.5455 51.6419 29.8582 50.9585 29.8582 50.1042C29.8582 49.2926 30.5455 48.5664 31.4048 48.5664Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3336 56.0007H9.88135V44.2539H37.3766V56.0007H37.3336ZM11.8576 54.0358H35.4003V46.2188H11.8576V54.0358Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1537 0H14.1775V3.11823H16.1537V0Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5542 0.962265L8.84302 1.94531L10.412 4.64539L12.1232 3.66234L10.5542 0.962265Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22712 4.56792L5.23901 6.26953L7.95494 7.82865L8.94305 6.12703L6.22712 4.56792Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38959 9.86719H4.25342V11.8321H7.38959V9.86719Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93607 13.8778L5.22046 15.4375L6.20896 17.1389L8.92457 15.5792L7.93607 13.8778Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3782 13.8765L21.3899 15.5781L24.1058 17.1376L25.0941 15.4359L22.3782 13.8765Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0776 9.86719H22.9414V11.8321H26.0776V9.86719Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1218 4.56464L21.4065 6.125L22.3954 7.82622L25.1107 6.26586L24.1218 4.56464Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7788 0.983208L18.2107 3.68359L19.9221 4.66605L21.4902 1.96566L19.7788 0.983208Z",
    fill: "#FF7900"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11711_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthMsisdn);
export default __webpack_public_path__ + "static/media/authMsisdn.da1ba69216c9639744367e6ff2eac576.svg";
export { ForwardRef as ReactComponent };